import { useEffect, useState } from "react";

let cached: boolean | null = null;
function detectFlexGap(): boolean {
    if (cached != null) return cached;
    try {
        const flex = document.createElement('div');
        flex.style.display = 'flex';
        flex.style.flexDirection = 'row';
        flex.style.gap = '1px';
        flex.style.position = 'absolute';
        flex.style.visibility = 'hidden';
        const c1 = document.createElement('div'); c1.style.width = '1px'; c1.style.height = '1px';
        const c2 = document.createElement('div'); c2.style.width = '1px'; c2.style.height = '1px';
        flex.appendChild(c1); flex.appendChild(c2);
        document.body.appendChild(flex);
        // gap이 지원되면 scrollWidth = 1(px child) + 1(gap) + 1(child) = 3
        const ok = flex.scrollWidth >= 3;
        document.body.removeChild(flex);
        cached = ok; return ok;
    } catch { cached = false; return false; }
}
export function useFlexGapSupport() {
    const [ok, setOk] = useState<boolean>(cached ?? true);
    useEffect(() => setOk(detectFlexGap()), []);
    return ok;
}
